// extracted by mini-css-extract-plugin
export default {"districtInfo":"DistrictInfo_districtInfo__WC53i"};